import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { valorReloj, timeService } from 'src/app/services/time.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MicroempresarioService } from '../services/microempresario.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { UtmTrackingService } from 'src/app/services/utm-tracking.service';

declare var $: any;
@Component({
    selector: 'microempresario-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [timeService],
    standalone: false
})
export class HeaderComponent implements OnInit {
  /**
   * Header v2 activo por defecto en todo el perfil micro.
   * El markup anterior queda comentado en el template (no eliminar todavía).
   * @deprecated Preferir siempre v2; se conserva por rollback.
   */
  @Input() skin: 'legacy' | 'v2' = 'v2';

  userName: string = '';
  ultimaConexion: string = '';
  ip: string = '';
  fechaActual: Observable<valorReloj>;
  hora: number;
  minutos: string;
  dia: string;
  fecha: string;
  ampm: string;
  segundos: string;
  notificacionForm: UntypedFormGroup;

  constructor(
    private _user: UserService,
    private time: timeService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private _micro: MicroempresarioService,
    private _modal: SweetAlertService,
    private readonly utmTracking: UtmTrackingService
  ) {
    this.notificacionForm = this.fb.group({
      idEmpresario: ['', Validators.required],
      habilitarCorreos: ['', Validators.required]
    });
  }

  ngOnInit() {
    const user = this._user.getUser();
    // TEMPORAL QA: header usable sin sesión (vista previa UI sin back)
    this.userName = user?.nombre ?? 'Vista previa';
    if (user) {
      this.notificacionForm.get('idEmpresario').setValue(+user.idEmpresario);
      this.ultimaConexion = user.fechaUltimoAcceso;
      this.ip = user.ip;
    }
    this.fechaActual = this.time.getInfoReloj();
    this.fechaActual.subscribe((x) => {
      this.hora = x.hora;
      this.minutos = x.minutos;
      this.dia = x.diadesemana;
      this.fecha = x.diaymes;
      this.ampm = x.ampm;
      this.segundos = x.segundo;
    });
  }

  get isV2(): boolean {
    // Header v2 es el activo; el markup anterior solo existe comentado en el template.
    return true;
  }

  async closeSession() {
    this.utmTracking.registrarFinalizacionSesion();
    await this._user.deleteUser();
    this.router.navigateByUrl('/home');
  }

  validateField(key: string) {
    return (
      (this.notificacionForm.get(key).dirty || this.notificacionForm.get(key)?.touched) &&
      this.notificacionForm.get(key)?.invalid
    );
  }

  getModal(){
    $('#modal-notificaciones').modal('show');
  }

  saveNotificacion(){
    this._micro.putNotificaciones(this.notificacionForm.value).subscribe((resp:any) => {
      if (resp.exitoso) {
        if (!this.notificacionForm.get('habilitarCorreos').value) {
          this._modal.successModal('Desuscribir notificaciones', false,'Te informamos que te has desuscrito de las notificaciones de neocrédito. A partir de la fecha no recibirás más información de la plataforma. Recuerda que puedes volver a activarlas cuando lo requieras por la opción de "Desuscribir notificaciones" de tu perfil'
          );         
        } else {
          this._modal.successModal('Suscribir notificaciones', false,'Te informamos que te has suscrito a las notificaciones de neocrédito. A partir de la fecha vuelves a recibir información de la plataforma.');
        }
        $('#modal-notificaciones').modal('hide');
        this.notificacionForm.get('habilitarCorreos').reset();
      } else {
        this._modal.errorModal("¡Error!",true, resp.error);
        $('#modal-notificaciones').modal('hide');
      }
    });
  }
}
